"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabSet = void 0;

var React = require("react");

var __1 = require("..");

var Actions_1 = require("../model/Actions");

var PopupMenu_1 = require("../PopupMenu");

var TabButton_1 = require("./TabButton");

var MAX_TABS = 999;
/** @hidden @internal */

var TabSet =
/** @class */
function (_super) {
  __extends(TabSet, _super);

  function TabSet(props) {
    var _this = _super.call(this, props) || this;

    _this.onOverflowClick = function (hiddenTabs) {
      // console.log("hidden tabs: " + hiddenTabs);
      var element = _this.overflowbuttonRef.current;
      PopupMenu_1.default.show(element, hiddenTabs, _this.onOverflowItemSelect, _this.props.layout.getClassName);
    };

    _this.onOverflowItemSelect = function (item) {
      _this.props.layout.doAction(Actions_1.default.selectTab(item.node.getId()));
    };

    _this.onMouseDown = function (event) {
      var name = _this.props.node.getName();

      if (name === undefined) {
        name = "";
      } else {
        name = ": " + name;
      }

      _this.props.layout.doAction(Actions_1.default.setActiveTabset(_this.props.node.getId()));

      var message = _this.props.layout.i18nName(__1.I18nLabel.Move_Tabset, name);

      _this.props.layout.dragStart(event, message, _this.props.node, _this.props.node.isEnableDrag(), function (event2) {
        return undefined;
      }, _this.onDoubleClick);
    };

    _this.onInterceptMouseDown = function (event) {
      event.stopPropagation();
    };

    _this.onMaximizeToggle = function () {
      if (_this.props.node.isEnableMaximize()) {
        _this.props.layout.maximize(_this.props.node);
      }
    };

    _this.onDoubleClick = function (event) {
      if (_this.props.node.isEnableMaximize()) {
        _this.props.layout.maximize(_this.props.node);
      }
    };

    _this.hideTabsAfter = MAX_TABS;
    _this.showOverflow = false;
    _this.showToolbar = true;
    _this.renderAllTabs = true;
    _this.toolbarRef = React.createRef();
    _this.overflowbuttonRef = React.createRef();
    return _this;
  }

  TabSet.prototype.componentDidMount = function () {
    this.updateVisibleTabs();
  };

  TabSet.prototype.shouldComponentUpdate = function () {
    this.renderAllTabs = true; // since not the force update of a second render to adjust tabs

    return true;
  };

  TabSet.prototype.componentDidUpdate = function () {
    this.updateVisibleTabs();
  };
  /*
      Since selected tab is always shown, move it to first position when
      determining the number for tabs that can be shown
   */


  TabSet.getModifiedNodeList = function (nodes, selectedIndex) {
    var modifiedChildren = __spreadArrays(nodes);

    if (selectedIndex !== -1 && selectedIndex !== 0) {
      var selected = nodes[selectedIndex];
      var selectedRect = selected.getTabRect(); // move selected node to first position

      modifiedChildren.splice(selectedIndex, 1);
      modifiedChildren.unshift(selected);
      selected.getTabRect().x = nodes[0].getTabRect().x;
      selected.getTabRect().y = nodes[0].getTabRect().y; // for vertical border
      // adjust x,y of tabs 1-selectedindex to account for insersion of selected at 0

      for (var i = 1; i <= selectedIndex; i++) {
        var child = modifiedChildren[i];
        child.getTabRect().x += selectedRect.width;
        child.getTabRect().y += selectedRect.height; // for vertical border
      }
    }

    return modifiedChildren;
  };

  TabSet.prototype.updateVisibleTabs = function () {
    if (this.renderAllTabs) {
      var node = this.props.node;

      if (node.isEnableTabStrip() && node.getChildren().length > 0) {
        var toolbarWidth = this.toolbarRef.current.getBoundingClientRect().width;
        var lastChild = node.getChildren()[node.getChildren().length - 1];

        if (lastChild.getTabRect().getRight() > node.getRect().getRight() - toolbarWidth) {
          var modifiedChildren = TabSet.getModifiedNodeList(node.getChildren(), this.props.node.getSelected());

          for (var i = 0; i < modifiedChildren.length; i++) {
            var child = modifiedChildren[i];

            if (child.getTabRect().getRight() > node.getRect().getRight() - (20 + toolbarWidth)) {
              this.hideTabsAfter = Math.max(0, i - 1);
              this.showOverflow = node.getChildren().length > 1;

              if (i === 0) {
                this.showToolbar = false;

                if (child.getTabRect().getRight() > node.getRect().getRight() - 20) {
                  this.showOverflow = false;
                }
              }

              this.renderAllTabs = false;
              this.forceUpdate(); // re-render to hide some tabs

              return;
            }
          }
        }
      }
    } else {
      this.renderAllTabs = true;
    }
  };

  TabSet.prototype.render = function () {
    if (this.renderAllTabs) {
      this.hideTabsAfter = MAX_TABS;
      this.showOverflow = false;
      this.showToolbar = true;
    }

    var cm = this.props.layout.getClassName;
    var node = this.props.node;

    var style = node._styleWithPosition();

    if (this.props.node.isMaximized()) {
      style.zIndex = 100;
    }

    var tabs = [];
    var hiddenTabs = [];

    if (node.isEnableTabStrip()) {
      for (var i = 0; i < node.getChildren().length; i++) {
        var isSelected = this.props.node.getSelected() === i;
        var showTab = this.hideTabsAfter >= i;
        var child = node.getChildren()[i];

        if (this.hideTabsAfter === i && this.props.node.getSelected() > this.hideTabsAfter) {
          hiddenTabs.push({
            name: child.getName(),
            node: child,
            index: i
          });
          child = node.getChildren()[this.props.node.getSelected()];
          isSelected = true;
        } else if (!showTab && !isSelected) {
          hiddenTabs.push({
            name: child.getName(),
            node: child,
            index: i
          });
        }

        if (showTab) {
          tabs.push(React.createElement(TabButton_1.TabButton, {
            layout: this.props.layout,
            node: child,
            key: child.getId(),
            selected: isSelected,
            show: showTab,
            height: node.getTabStripHeight(),
            iconFactory: this.props.iconFactory,
            titleFactory: this.props.titleFactory,
            closeIcon: this.props.closeIcon
          }));
        }
      }
    } // tabs.forEach(c => console.log(c.key));


    var buttons = []; // allow customization of header contents and buttons

    var renderState = {
      headerContent: node.getName(),
      buttons: buttons
    };
    this.props.layout.customizeTabSet(this.props.node, renderState);
    var headerContent = renderState.headerContent;
    buttons = renderState.buttons;
    var toolbar;

    if (this.showToolbar === true) {
      if (this.props.node.isEnableMaximize()) {
        buttons.push(React.createElement("button", {
          key: "max",
          "aria-label": node.isMaximized() ? "Minimize" : "Maximize",
          className: cm("flexlayout__tab_toolbar_button-" + (node.isMaximized() ? "max" : "min")),
          onClick: this.onMaximizeToggle
        }));
      }

      toolbar = React.createElement("div", {
        key: "toolbar",
        ref: this.toolbarRef,
        className: cm("flexlayout__tab_toolbar"),
        onMouseDown: this.onInterceptMouseDown
      }, buttons);
    }

    if (this.showOverflow === true && hiddenTabs.length > 0) {
      tabs.push(React.createElement("button", {
        key: "overflowbutton",
        ref: this.overflowbuttonRef,
        className: cm("flexlayout__tab_button_overflow"),
        onTouchStart: this.onInterceptMouseDown,
        onClick: this.onOverflowClick.bind(this, hiddenTabs),
        onMouseDown: this.onInterceptMouseDown
      }, hiddenTabs.length));
    }

    var showHeader = node.getName() !== undefined;
    var header;
    var tabStrip;
    var tabStripClasses = cm("flexlayout__tab_header_outer");

    if (this.props.node.getClassNameTabStrip() !== undefined) {
      tabStripClasses += " " + this.props.node.getClassNameTabStrip();
    }

    if (node.isActive() && !showHeader) {
      tabStripClasses += " " + cm("flexlayout__tabset-selected");
    }

    if (node.isMaximized() && !showHeader) {
      tabStripClasses += " " + cm("flexlayout__tabset-maximized");
    }

    if (showHeader) {
      var tabHeaderClasses = cm("flexlayout__tabset_header");

      if (node.isActive()) {
        tabHeaderClasses += " " + cm("flexlayout__tabset-selected");
      }

      if (node.isMaximized()) {
        tabHeaderClasses += " " + cm("flexlayout__tabset-maximized");
      }

      if (this.props.node.getClassNameHeader() !== undefined) {
        tabHeaderClasses += " " + this.props.node.getClassNameHeader();
      }

      header = React.createElement("div", {
        className: tabHeaderClasses,
        style: {
          height: node.getHeaderHeight() + "px"
        },
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onMouseDown
      }, headerContent, toolbar);
      tabStrip = React.createElement("div", {
        className: tabStripClasses,
        style: {
          height: node.getTabStripHeight() + "px",
          top: node.getHeaderHeight() + "px"
        }
      }, React.createElement("div", {
        className: cm("flexlayout__tab_header_inner")
      }, tabs));
    } else {
      tabStrip = React.createElement("div", {
        className: tabStripClasses,
        style: {
          top: "0px",
          height: node.getTabStripHeight() + "px"
        },
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onMouseDown
      }, React.createElement("div", {
        className: cm("flexlayout__tab_header_inner")
      }, tabs), toolbar);
    }

    return React.createElement("div", {
      style: style,
      className: cm("flexlayout__tabset")
    }, header, tabStrip);
  };

  return TabSet;
}(React.Component);

exports.TabSet = TabSet; // export default TabSet;